import { create } from "zustand";

export interface LoginDialogOptions {
	onLoginSuccess?: () => void;
	isShort?: boolean;
}

interface LoginDialogState {
	isOpen: boolean;
	dialogOptions: LoginDialogOptions;
	openDialog: (options?: LoginDialogOptions) => void;
	closeDialog: () => void;
	setIsOpen: (isOpen: boolean) => void;
}

export const useLoginDialogStore = create<LoginDialogState>(set => ({
	isOpen: false,
	dialogOptions: {},
	openDialog: (options: LoginDialogOptions = {}) => {
		set({ dialogOptions: options, isOpen: true });
	},
	closeDialog: () => set({ isOpen: false }),
	setIsOpen: (isOpen: boolean) => set({ isOpen }),
}));
